import React from 'react';
import PropTypes, { object, string } from 'prop-types';
import { components } from 'react-select';

import SelectOption from '../SelectOption/SelectOption';

const OptionPart = props => {
  const { isSelected, data } = props;
  const {
    groupStatus,
    selectAllStatus,
    value,
    limit,
    allValueOptions,
    offTrendline
  } = props.selectProps;
  const counterSelectOptions = value.length;
  return (
    <>
      <components.Option {...props}>
        <SelectOption
          isSelected={isSelected}
          data={data}
          groupStatus={groupStatus}
          selectAllStatus={selectAllStatus}
          counterSelectOptions={counterSelectOptions}
          limit={limit}
          value={value}
          allValueOptions={allValueOptions}
          offTrendline={offTrendline}
        />
      </components.Option>
    </>
  );
};

OptionPart.propTypes = {
  isSelected: PropTypes.bool,
  options: PropTypes.oneOfType([
    PropTypes.arrayOf(string),
    PropTypes.arrayOf(object)
  ]),
  data: PropTypes.oneOfType([PropTypes.arrayOf(object), PropTypes.object]),
  isMulti: PropTypes.bool,
  selectProps: PropTypes.object,
  offTrendline: PropTypes.bool
};

export default OptionPart;
